import CryptoJS from "crypto-js";

const SECRET_KEY = "aghjgfgy345wrmwfmi23523rf23cs";

// Save encrypted session data
export const setSessionData = (key, value) => {
  try {
    const ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      SECRET_KEY
    ).toString();
    sessionStorage.setItem(key, ciphertext);
  } catch (err) {
    console.error(`Error encrypting session data for ${key}:`, err);
  }
};

// Get decrypted session data
export const getSessionData = (key) => {
  try {
    const storedData = sessionStorage.getItem(key);
    if (!storedData) return null;

    const bytes = CryptoJS.AES.decrypt(storedData, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedData ? JSON.parse(decryptedData) : null;
  } catch (err) {
    console.error(`Error decrypting session data for ${key}:`, err);
    return null;
  }
};

// Remove session data
export const clearSessionData = (key) => {
  sessionStorage.removeItem(key);
};
